'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _isObject = require('lodash/isObject');var _isObject2 = _interopRequireDefault(_isObject);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _containers = require('../../../containers');
var _components = require('../../../components');
var _OMMultiPinCell = require('../OMPropertyCells/OMMultiPinCell');var _OMMultiPinCell2 = _interopRequireDefault(_OMMultiPinCell);

var _constants = require('../../../constants');







var _formatSEOData = require('../../../utils/formatSEOData');
var _formatMessage = require('../../../utils/formatMessage');var _formatMessage2 = _interopRequireDefault(_formatMessage);
var _checkIsNewProperty = require('../../../utils/checkIsNewProperty');
var _getLocalizedData = require('../../../utils/getLocalizedData');var _getLocalizedData2 = _interopRequireDefault(_getLocalizedData);

var _OMPropertiesList = require('./OMPropertiesList.scss');var styles = _interopRequireWildcard(_OMPropertiesList);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
// Styles
var OMPropertiesList = function (_Component) {_inherits(OMPropertiesList, _Component);function OMPropertiesList() {var _temp, _this, _ret;_classCallCheck(this, OMPropertiesList);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      deletePropertyId: null,
      deleteModalIsOpen: false }, _this.


    getCellComponent = function () {var
      className = _this.props.className;

      switch (className) {
        case 'inManagePropertiesMobile':
          return _components.OMRegularManageCellMobile;
        case 'multiPinList':
          return _OMMultiPinCell2.default;
        default:
          return _components.PropertyCell;}

    }, _this.

    createList = function (properties) {var _this$props =











      _this.props,locale = _this$props.locale,translate = _this$props.translate,propertiesAnalytics = _this$props.propertiesAnalytics,editable = _this$props.editable,updateAutoJumpToTopActivity = _this$props.updateAutoJumpToTopActivity,updatePropertyHighlighting = _this$props.updatePropertyHighlighting,updateTopPromotionActivity = _this$props.updateTopPromotionActivity,disabledPromotionAction = _this$props.disabledPromotionAction,openMessageModal = _this$props.openMessageModal,isCanManagePromotions = _this$props.isCanManagePromotions;
      var CellComponent = _this.getCellComponent();

      return properties.map(function (property) {
        var isLand = property.property_type === 'land'; // temp patch
        var englishAddressRequired = _constants.localesWithEnglishAddress.includes(locale);
        var address = englishAddressRequired ?
        property.address.en :
        property.address[locale] || property.address[_constants.language.default];

        var houseNumber = address.house_number ? ' ' + address.house_number + ',' : '';
        var stringAddress = address.street_name + ' ' + houseNumber;

        var cityName = address.city_name;
        var isFavorite = _this.props.favoriteProperties &&
        _this.props.favoriteProperties.indexOf(property.id) !== -1;

        var additionalInfo = property.additional_info || {};
        var optionType = _this.props.translate('propertyDetails', 'propertyType', property.search_option);
        var propertyType = _this.props.translate('propertyTypes', property.property_type)();

        var optionAndPropertyTypesTitle = _this.props.editable ?
        propertyType + ' ' + optionType :
        '';
        var floor = isLand ? undefined : (0, _get2.default)(property, 'additional_info.floor.on_the');
        var rooms = isLand ? undefined : additionalInfo.rooms;var _property$address$loc =

        property.address.location,lat = _property$address$loc.lat,lon = _property$address$loc.lon;
        var thumbnail = property.thumbnail || null;

        var isNewProperty = !editable && property.created_at && _this.props.todayDate &&
        (0, _checkIsNewProperty.checkIsNewProperty)(property.created_at, _this.props.todayDate);

        var isPublishedToday = property.created_at && _this.props.todayDate &&
        (0, _checkIsNewProperty.checkIsPublishedToday)(property.created_at, _this.props.todayDate);

        var canMoveToTop =
        !property.is_autojump_enabled &&
        property.move_to_top &&
        !property.is_promoted &&
        !property.is_top_promoted;

        var canSecondJump = !property.is_autojump_enabled &&
        !isPublishedToday &&
        !canMoveToTop &&
        !property.shared_today;

        var sharingTitle = (0, _formatSEOData.formatPropertyTitle)(
        property,
        propertyType,
        translate('propertyDetails'),
        locale);


        var propertyAnalyticsData = propertiesAnalytics &&
        propertiesAnalytics.data && propertiesAnalytics.data.find(function (item) {return item.id === property.id;});var _ref =
        propertyAnalyticsData || {},events = _ref.events;
        var propertyViewEvent = events && events.find(function (item) {return item.action === _constants.analyticsEventAction.VIEW;});var _ref2 =
        propertyViewEvent || {},propertyViews = _ref2.count;

        var propertyAnalyticsFavouritesData = propertiesAnalytics && propertiesAnalytics.favoritesData &&
        propertiesAnalytics.favoritesData.find(function (item) {return item.id === property.id;});var _ref3 =
        propertyAnalyticsFavouritesData || {},favoritesEvents = _ref3.events;
        var propertyFavoritesEvent = favoritesEvents &&
        favoritesEvents.find(function (item) {return item.action === _constants.analyticsEventAction.FAVOURITES;});var _ref4 =
        propertyFavoritesEvent || {},propertyFavorites = _ref4.count;

        var propertyAnalyticsNumberData = propertiesAnalytics && propertiesAnalytics.ShowNumberData &&
        propertiesAnalytics.ShowNumberData.find(function (item) {return item.id === property.id;});var _ref5 =
        propertyAnalyticsNumberData || {},numberEvents = _ref5.events;
        var propertyNumberEvent = numberEvents &&
        numberEvents.find(function (item) {return item.action === _constants.analyticsEventAction.SHOW_NUMBER;});var _ref6 =
        propertyNumberEvent || {},propertyNumber = _ref6.count;

        var createdAt = property.created_at;
        var openJumpToTopModal = function openJumpToTopModal() {return _this.props.openJumpToTopModal(property, true);};
        var name = (0, _getLocalizedData2.default)(property.name, locale);
        var price = property.price || property.min_property_price;
        var statusLocaliseData = _constants.projectStatuses.find(function (item) {return item.name === property.status;}) || {};
        var status = (0, _getLocalizedData2.default)(statusLocaliseData.localisation, locale);
        var image = property.entityType === _constants.ENTITY_TYPES.PROJECT ? (0, _get2.default)(property, 'images[0]', null) : null;

        return (
          _react2.default.createElement('div', { key: property.id },
            _react2.default.createElement(CellComponent, {
              userProperties: _this.props.userProperties,
              property: property,
              id: property.id,
              locale: locale,
              photo: image || thumbnail,
              price: price,
              addressData: property.address,
              address: stringAddress,
              city: cityName,
              isCanManagePromotions: isCanManagePromotions,
              updateAutoJumpToTopActivity: updateAutoJumpToTopActivity,
              updatePropertyHighlighting: updatePropertyHighlighting,
              updateTopPromotionActivity: updateTopPromotionActivity,
              disabledPromotionAction: disabledPromotionAction,
              openMessageModal: openMessageModal,
              rooms: rooms,
              parkingSpots: additionalInfo.parking,
              openDetailsPopup: _this.props.openDetailsPopup,
              area: (0, _isObject2.default)(additionalInfo.area) ? additionalInfo.area.base : additionalInfo.area // for migration purposes
              , floor: floor,
              description: property.description,
              optionAndPropertyTypes: optionAndPropertyTypesTitle,
              parkingIconTitle: _this.props.translate('iconTitles', 'parkingIcon'),
              roomsIconTitle: _this.props.translate('iconTitles', 'roomsIcon'),
              squareIconTitle: _this.props.translate('iconTitles', 'squareIcon'),
              floorIconTitle: _this.props.translate('iconTitles', 'floorIcon'),
              groundFloorTitle: _this.props.translate('propertyDetails', 'details', 'groundFloorShortcut'),
              className: _this.props.className,
              editButtonText: _this.props.translate('edit'),
              copyLinkText: _this.props.translate('copyLink'),
              shareButtonText: _this.props.translate('share'),
              openDetailsButtonText: _this.props.translate('openDetails'),
              deleteButtonText: _this.props.translate('propertyDetails', 'delete'),
              activeButtonText: _this.props.translate('propertyDetails', 'activate'),
              inactiveButtonText: _this.props.translate('propertyDetails', 'deactivate'),
              makeActiveText: _this.props.translate('propertyDetails', 'makeActive'),
              makeInactiveText: _this.props.translate('propertyDetails', 'makeInactive'),
              jumpToTopText: _this.props.translate('propertyDetails', 'jumpToTop'),
              jumpToTopTooltipText: _this.props.translate('propertyDetails', 'jumpToTopTooltip'),
              propertyViewsText: _this.props.translate('propertyDetails', 'views'),
              upgradePackageButtonText: _this.props.translate('propertyDetails', 'upgradePackage'),
              bathrooms: property.bathrooms,
              editProperty: _this.props.editProperty,
              editable: _this.props.editable,
              isMobile: _this.props.isMobile,
              isActive: property.is_active,
              updatePropertyActivity: _this.props.updatePropertyActivity,
              movePropertyToTop: _this.props.movePropertyToTop,
              canMoveToTop: canMoveToTop,
              canSecondJump: canSecondJump,
              showCantMakeActiveModal: _this.showCantMakeActiveModal,
              showDeleteModal: _this.showDeleteModal,
              propertyType: propertyType || name.result,
              toggleFavorite: _this.props.toggleFavorite,
              isFavorite: isFavorite,
              mapPropertyCell: _this.props.mapPropertyCell,
              isRtl: _this.props.isRtl,
              promotedTitle: _this.props.promotedTitle,
              suspended: property.is_suspended,
              suspendedTitle: _this.props.suspendedTitle,
              suspendedTooltipMessage: _this.props.suspendedTooltipMessage,
              sharingTitle: sharingTitle,
              suppressLoading: _this.props.suppressLoading,
              isNewProperty: isNewProperty,
              isModalShareOpen: _this.props.isModalShareOpen,
              hideModalShare: _this.props.hideModalShare,
              openModalShare: _this.props.openModalShare,
              openJumpToTopModal: openJumpToTopModal,
              newPropertyLabel: _this.props.translate('iconTitles', 'newPropertyLabel')(),
              newPropertyTitle: _this.props.translate('iconTitles', 'newPropertyTitle')(),
              autoDeactivatedProperty: _this.props.autoDeactivatedProperty,
              openChartOfViews: _this.props.openChartOfViews,
              propertyViews: propertyViews,
              propertyFavorites: propertyFavorites,
              propertyNumber: propertyNumber,
              loadSinglePropertyAnalytics: _this.props.loadSinglePropertyAnalytics,
              createdAt: createdAt,
              translate: _this.props.translate,
              promoted: property.is_promoted,
              hasVRLink: !!property.vr_link,
              autoJumpEnabled: property.is_autojump_enabled,
              isTopPromotedProperty: property.is_top_promoted,
              modalShareId: _this.props.modalShareId,
              propertyEntityType: property.entityType,
              status: status.result,
              searchOption: property.search_option,
              openUpgradePackageModal: _this.props.openUpgradePackageModal })));



      });
    }, _this.

    showCantMakeActiveModal = function () {
      var message = (0, _formatMessage2.default)(_this.props.translate('propertyDetails', 'cantMakeActive'), [
      (0, _constants.getSupportEmail)(),
      (0, _constants.getSupportEmail)()]);

      _this.props.openMessageModal({
        message:
        _react2.default.createElement('div', { className: 'contentMessage' },
          _react2.default.createElement('p', { className: styles.modalMessageWrapper, dangerouslySetInnerHTML: { __html: message } })) });



    }, _this.

    showDeleteModal = function (id) {
      _this.setState({
        deletePropertyId: id,
        deleteModalIsOpen: true });

    }, _this.

    hideDeleteModal = function () {return _this.setState({
        deletePropertyId: null,
        deleteModalIsOpen: false });}, _this.


    handleDeleteProperty = function (_ref7) {var option = _ref7.option,answer = _ref7.answer;

    }, _temp), _possibleConstructorReturn(_this, _ret);}OMPropertiesList.prototype.

  render = function render() {var _props =
    this.props,translate = _props.translate,propertiesAnalytics = _props.propertiesAnalytics,closeChartOfViews = _props.closeChartOfViews,editable = _props.editable;
    return (
      _react2.default.createElement('div', { className: this.props.needScroll ? styles.scrollPropertiesList : styles.wrap },
        this.createList(this.props.properties),

        this.props.editable && this.state.deleteModalIsOpen ?
        _react2.default.createElement(_components.DeletePropertyModal, {
          isOpen: this.state.deleteModalIsOpen,
          hideDeleteModal: this.hideDeleteModal,
          headerText: this.props.translate('propertyDetails', 'deletePropertyQuestion'),
          selectPlaceholder: this.props.translate('propertyDetails', 'choose'),
          inputPlaceholder: this.props.translate('propertyDetails', 'answer'),
          errorText: this.props.translate('propertyDetails', 'pleaseChooseAnAnswer'),
          deleteOptions: [{ label: 'Delete please', value: 'simple' }, { label: 'אחר', value: 'other' }],
          handleSubmit: this.handleDeleteProperty,
          deleteButtonText: this.props.translate('propertyDetails', 'deleteButtonText'),
          cancelButtonText: this.props.translate('propertyDetails', 'cancelButtonText') }) :

        null,
        editable && _react2.default.createElement(_containers.ChartOfViews, {
          translate: translate,
          propertiesAnalytics: propertiesAnalytics,
          onRequestClose: closeChartOfViews,
          isRtl: this.props.isRtl })));



  };return OMPropertiesList;}(_react.Component);exports.default = OMPropertiesList;


OMPropertiesList.propTypes = {
  locale: _propTypes2.default.string.isRequired,
  isMobile: _propTypes2.default.bool,
  properties: _propTypes2.default.array,
  translate: _propTypes2.default.func,
  className: _propTypes2.default.string,
  openDetailsPopup: _propTypes2.default.func,
  editProperty: _propTypes2.default.func,
  editable: _propTypes2.default.bool,
  needScroll: _propTypes2.default.bool,
  updatePropertyActivity: _propTypes2.default.func,
  movePropertyToTop: _propTypes2.default.func,
  favoriteProperties: _propTypes2.default.array,
  toggleFavorite: _propTypes2.default.func,
  openMessageModal: _propTypes2.default.func,
  isModalShareOpen: _propTypes2.default.bool,
  hideModalShare: _propTypes2.default.func,
  openModalShare: _propTypes2.default.func,
  openJumpToTopModal: _propTypes2.default.func,
  mapPropertyCell: _propTypes2.default.bool,
  promotedTitle: _propTypes2.default.string,
  suspendedTitle: _propTypes2.default.string,
  suspendedTooltipMessage: _propTypes2.default.string,
  isRtl: _propTypes2.default.bool,
  suppressLoading: _propTypes2.default.func,
  todayDate: _propTypes2.default.object,
  autoDeactivatedProperty: _propTypes2.default.string,
  propertiesAnalytics: _propTypes2.default.object,
  closeChartOfViews: _propTypes2.default.func,
  openChartOfViews: _propTypes2.default.func,
  modalShareId: _propTypes2.default.string,
  loadSinglePropertyAnalytics: _propTypes2.default.func,
  openUpgradePackageModal: _propTypes2.default.func,
  userProperties: _propTypes2.default.object,
  updateAutoJumpToTopActivity: _propTypes2.default.func,
  updatePropertyHighlighting: _propTypes2.default.func,
  updateTopPromotionActivity: _propTypes2.default.func,
  disabledPromotionAction: _propTypes2.default.func,
  isCanManagePromotions: _propTypes2.default.bool };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMPropertiesList/OMPropertiesList.js
// module id = 2756
// module chunks = 0